const buttonStyle = {padding: '14px', marginRight: '10px', position: 'relative', top: '2px'}

export {buttonStyle}
